
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 30 30"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"stroke":"currentColor","stroke-width":"1.5","fill":"none","fill-rule":"evenodd","stroke-linecap":"round","stroke-linejoin":"round"}},[_c('path',{attrs:{"d":"M20.168 18a5.951 5.951 0 01-10.336 0H6a1.5 1.5 0 00-1.5 1.5V24A1.5 1.5 0 006 25.5h18a1.5 1.5 0 001.5-1.5v-4.5A1.5 1.5 0 0024 18h-3.832zM15 4.5V15M18.75 7.5L15 4.5l-3.75 3"}})])])
          )
        }
      }
    